import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import arrowLeftGray from "../../../assets/svg/arrowLeftGray.svg";
import blueArrowDown from "../../../assets/svg/blue-arrow-down.svg";
import uniqLogo from "../../../assets/svg/uniqLogo.svg";
import Snackbar from "../../../components/Snackbar/Snackbar";
import { adminMenu } from "../../../misc/constants";
import { useGlobalUserState } from "../../../stores/user";
import { MenuItem } from "./MenuItem";

export default function Root() {
  const navigate = useNavigate();
  const userState = useGlobalUserState();
  const [selectedItem, setSelectedItem] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const user = userState.get();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = adminMenu
      .flatMap((menuItem) => menuItem.nested)
      .find((nested) => nested.link === currentPath);

    if (matchedItem) {
      setSelectedItem(matchedItem.key);
    }
  }, [location.pathname]);

  const renderMenuItem = (item, id) => {
    return (
      <MenuItem
        item={item}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        isMenuOpen={isMenuOpen}
        key={id}
      />
    );
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const logOut = () => {
    userState.set({});
    navigate("/admin/login")
  }

  return (
    <div
      className={
        "flex flex-row min-h-screen bg-[#F3FBF9] text-white overflow-auto"
      }
    >
      <div
        className={`${isMenuOpen ? "w-[240px]" : "w-20"
          } min-h-screen menu-col flex flex-col items-center pt-4 px-4 bg-white`}
      >
        <div className="w-40 h-10 mb-8">
          {isMenuOpen && <img src={uniqLogo} alt="logo" />}
        </div>
        <img
          src={isMenuOpen ? arrowLeftGray : blueArrowDown}
          className="self-start cursor-pointer h-7"
          onClick={toggleMenu}
        />
        {adminMenu.map((menuItem, id) => renderMenuItem(menuItem, id))}
        <div
          className={`flex flex-col w-full cursor-pointer px-8 py-3 rounded-lg`}
          onClick={logOut}
          key={"logout"}
        >
          <p
            className={`text-[15px] font-medium ml-3 text-valley-red`}
          >
            Выйти
          </p>
        </div>
      </div>
      <div className={"main-col min-h-screen h-screen  w-full min-w-0"}>
        <Outlet />
      </div>
      <Snackbar />
    </div>
  );
}
